import styled, { css } from 'styled-components';

import Colours from '/shared/styled/Colours';

interface StyledTabBarItemProps {
  $isActive?: boolean;
}

function isActiveStyle({ $isActive = false }: StyledTabBarItemProps) {
  if ($isActive) {
    return css`
      button {
        background: ${Colours.green};
        color: ${Colours.white};
        cursor: default;
      }
    `;
  }
}

export const StyledTabBarItem = styled.li<StyledTabBarItemProps>`
  margin-right: 1rem;

  button {
    appearance: none;
    border: 0;
    padding: 1rem 2rem;
    cursor: pointer;
  }
  ${isActiveStyle}
`;

export default styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  border-bottom: 0.25rem solid ${Colours.green};
  margin-bottom: 2rem;
`;
